import React from 'react';
import ServicesContext from '../../../contexts/ServicesContext';
import { CustomerRecipe } from '../../../models/CustomerRecipe';
import { CardCustomerRecipe } from '../../ModalRecipesV2/CardCustomerRecipe/CardCustomerRecipe';

interface ICustomerRecipeListProps {
  customerId?: number;
  linkRecipe: (recipe: CustomerRecipe) => void;
}

export const CustomerRecipeList: React.FC<ICustomerRecipeListProps> = ({
  customerId,
  linkRecipe
}) => {

  const [customerRecipeHistory, setCustomerRecipeHistory] = React.useState<CustomerRecipe[]>([]);

  const {
    getCustomerRecipeHistoryByIdService
  } = React.useContext(ServicesContext);

  React.useEffect(() => {
    getCustomerRecipeHistory();
  }, [customerId]);

  return (
    <>
      {customerRecipeHistory.map(customerRecipe => {
        return (
          <CardCustomerRecipe
            key={`customer-recipe-${customerRecipe.id}`}
            recipe={customerRecipe}
            showExpanded={false}
            linkRecipe={() => linkRecipe(customerRecipe)}
          />
        )
      })}
    </>
  );

  function getCustomerRecipeHistory() {
    if (!customerId) return;

    getCustomerRecipeHistoryByIdService.handle({customerId})
      .then(result => {
        setCustomerRecipeHistory(result?.value?.recipes || []);
      });
  }
}